export default {
  title: "Performed Work must be reviewed!",
  body_content:
    "The open <b class='text-info'>Performed Corrective Work</b> must be either <b class='text-negative'>rejected</b> or <b class='text-positive'>accepted</b> before the <b class='text-info'>Issue</b> can be {operation}.",
  closed: "closed",
  rejected: "rejected",
  superseded: "superseded",
  deleted: "deleted",
}
